import CalenderIcon from "@assets/images/calendar.svg";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import locale from "date-fns/locale/en-US";
import moment from "moment-timezone";
import React, { useCallback } from "react";
import InlineSVG from "react-inlinesvg";

import CustomActionBar from "./CustomActionBar";
import { DatePickerProps, useStyles } from "./DatePicker";

const formatValue = value =>
  value ? moment(value).format("YYYY-MM-DD") : null;
if (locale?.options) {
  locale.options.weekStartsOn = 1;
}
const DatePickerV2Component: React.FC<DatePickerProps> = ({
  name,
  error = false,
  value,
  isReset,
  onChange,
  helperText,
  onAccept,
  placeholder,
  disableManualInput = true,
  placeholderColor,
  noBlock,
  disabledInitialRendering,
  placement = "bottom",
  disableFuture,
  dateRange,
  type,
  isAllowTodayDate,
  ...args
}) => {
  const classes = useStyles({ placeholderColor, allowEdit: true });

  function handleChange(date) {
    onChange({
      target: {
        name,
        value: formatValue(date)
      }
    });
  }

  const minDate = args.minDate
    ? moment(args.minDate)
    : moment().subtract(10, "years");
  const maxDate = args.maxDate
    ? moment(args.maxDate)
    : moment().add(10, "years");

  const renderAction = props => (
    <CustomActionBar
      minDate={minDate}
      isAllowTodayDate
      maxDate={maxDate}
      dateRange={dateRange}
      type={type}
      {...props}
    />
  );

  const selectIcon = () => (
    <InlineSVG src={CalenderIcon} width={18} height={18} />
  );

  const getMaxDate = useCallback(() => {
    if (disableFuture) {
      if (moment(maxDate).isAfter(moment())) {
        return moment();
      } else {
        return maxDate;
      }
    } else {
      return maxDate;
    }
  }, [disableFuture, maxDate]);

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <div className={classes.datePickerWrapper}>
        <DesktopDatePicker
          views={["year", "month", "day"]}
          slots={{
            openPickerIcon: () => selectIcon(),
            actionBar: props => renderAction(props)
          }}
          slotProps={{
            actionBar: { actions: ["today"] },
            textField: {
              helperText,
              error
            },
            popper: {
              className: classes.datePickerPopper,
              placement
            }
          }}
          disabled={args.disabled}
          format="DD/MM/YYYY"
          value={value ? moment(value) : null}
          defaultValue={args.defaultValue ? moment(args.defaultValue) : null}
          onAccept={__date => {
            handleChange(__date.toDate());
          }}
          onChange={value => {
            handleChange(value);
          }}
          minDate={minDate}
          maxDate={getMaxDate()}
          className={classes.datePickerv2}
        />
      </div>
    </LocalizationProvider>
  );
};

export default React.memo(DatePickerV2Component);
